'use client'

import { useState } from 'react'
import { DocumentAPIResponse } from '@/lib/redpim'
import { downloadAllProductResourcesAsZip } from '@/services/productResources.service'
import { Button, Download } from '@desoutter/uikit'

type DownloadAllButtonProps = {
	documents: DocumentAPIResponse
	partNumber: string
	translations: { downloadAll: string }
}

export default function DownloadAllButton({
	documents,
	partNumber,
	translations,
}: DownloadAllButtonProps) {
	const [isLoading, setIsLoading] = useState(false)

	const handleDownload = async () => {
		setIsLoading(true)
		try {
			await downloadAllProductResourcesAsZip(documents, partNumber)
		} catch (error) {
			console.error('Download error:', error)
		} finally {
			setIsLoading(false)
		}
	}

	return (
		<Button
			onClick={handleDownload}
			disabled={isLoading}
			isLoading={isLoading}
			color="tertiary"
			className="dark w-14 justify-center lg:w-auto text-[0px] gap-0 px-4 lg:text-base lg:gap-2 py-3 lg:py-2"
			icon={Download}
			iconBefore
		>
			{translations.downloadAll}
		</Button>
	)
}
